import { createSlice } from "@reduxjs/toolkit";

const methodologySlice = createSlice({
  name: "methodology",
  initialState: {
    cycles: [],
    report: {},
    reportAll: [],
    reportAllCMCS: [],
    nextContentsStudent: [],
    previousContentsStudent: [],
    currentCycleAndLevelStudent: [],
  },
  reducers: {
    setCycles(state, { payload }) {
      state.cycles = payload;
    },
    setReport(state, { payload }) {
      state.report = payload;
    },
    setReportAll(state, { payload }) {
      state.reportAll = payload;
    },
    setReportAllCMCS(state, { payload }) {
      state.reportAllCMCS = payload;
    },
    setCurrentCycleAndLevelStudent(state, { payload }) {
      state.currentCycleAndLevelStudent = payload;
    },
    setPreviousContentsStudent(state, { payload }) {
      state.previousContentsStudent = payload;
    },
    setNextContentsStudent(state, { payload }) {
      state.nextContentsStudent = payload;
    },
    clearReportStatus(state) {
      state.report = {};
      state.cycles = [];
      state.nextContentsStudent = [];
      state.previousContentsStudent = [];
      state.currentCycleAndLevelStudent = [];
    },
  },
});

export const {
  setReport,
  setCycles,
  setReportAll,
  setReportAllCMCS,
  clearReportStatus,
  setNextContentsStudent,
  setPreviousContentsStudent,
  setCurrentCycleAndLevelStudent,
} = methodologySlice.actions;

export default methodologySlice.reducer;
